import { useState, useEffect } from "react"
import { throttle } from "@/utils/performance"

const MOBILE_BREAKPOINT = 768
const TABLET_BREAKPOINT = 1024

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [isTablet, setIsTablet] = useState<boolean>(false)
  const [orientation, setOrientation] = useState<'portrait' | 'landscape'>('portrait')
  const [touchDevice, setTouchDevice] = useState<boolean>(false)

  useEffect(() => {
    const checkDevice = throttle(() => {
      const width = window.innerWidth
      const height = window.innerHeight
      
      setIsMobile(width < MOBILE_BREAKPOINT)
      setIsTablet(width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT)
      setOrientation(width < height ? 'portrait' : 'landscape')
      
      // Check for touch capability
      setTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0)
    }, 100)

    // Initial check
    checkDevice()

    // Add event listeners
    window.addEventListener('resize', checkDevice)
    window.addEventListener('orientationchange', checkDevice)

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkDevice)
      window.removeEventListener('orientationchange', checkDevice)
    }
  }, [])

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    orientation,
    touchDevice,
    // Legacy support
    valueOf: () => isMobile
  }
}

// Backward compatibility
export const useIsMobileLegacy = () => {
  const { isMobile } = useIsMobile()
  return isMobile
}